import React, { useState } from 'react';
import { FadeIn, CountdownTimer } from './Shared';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MEGAPACK CALMA TOTAL',
      subtitle: '6 Tomos + 4 Bonos',
      ideal: 'Ideal para: Padres y madres con hijos de 1 a 7 años que quieren manejar berrinches, poner límites y reconectar con sus hijos.',
      oldPrice: '$69.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48649260237017:1',
      buttonText: 'MEGAPACK CALMA TOTAL'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MEGAPACK CALMA TOTAL + MÉTODO RAÍCES',
      subtitle: '6 Tomos + 4 Bonos + Manual de Autoestima Infantil',
      ideal: 'Ideal para: Padres que ya quieren ir más allá de los berrinches y construir la autoestima, la resiliencia y la seguridad interior de su hijo.',
      oldPrice: '$89.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48649260368089:1',
      buttonText: 'MEGAPACK + MÉTODO RAÍCES',
      isPopular: true
    }
  };
  const currentPlan = plans[plan];
  return <section id="pricing" className="py-6 md:py-10 px-4 bg-navy-950 relative overflow-hidden" data-id="element-241">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-242">
        <FadeIn data-id="element-243">
          <div className="text-center mb-10" data-id="element-244">
            <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-245">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-246" />

            <div className="max-w-sm mx-auto mt-8 bg-navy-800/40 border border-navy-700/50 rounded-xl p-4 backdrop-blur-sm" data-id="element-247">
              <div className="flex justify-between items-center text-xs font-bold mb-2 uppercase tracking-wider" data-id="element-248">
                <span className="text-gray-300 flex items-center gap-1.5" data-id="element-249">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" data-id="element-250"></span>
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-red-400" data-id="element-251">68% Reclamado</span>
              </div>
              <div className="h-1.5 bg-navy-900 rounded-full overflow-hidden border border-navy-800" data-id="element-252">
                <div className="h-full bg-gradient-to-r from-yellow-500 via-amber-500 to-red-500 w-[68%] rounded-full relative" data-id="element-253">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-254"></div>
                </div>
              </div>
              <p className="text-[11px] text-gray-400 mt-2.5 font-medium" data-id="element-255">
                Quedan pocos accesos disponibles a precio de lanzamiento
              </p>
            </div>

            <p className="text-gray-200 mt-6 font-medium" data-id="element-256">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
            <h3 className="text-3xl md:text-5xl font-serif font-black text-white mt-10 mb-8 uppercase tracking-tight" data-id="element-257">
              ELEGÍ TU <span className="text-green-500" data-id="element-258">MEGAPACK</span>
            </h3>
          </div>

          <div id="planes-container" className="space-y-4 mb-8 scroll-mt-24" data-id="element-259">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} id={`plan-${p.id}`} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-300 rounded-2xl p-6 md:p-8 border-2 flex items-center gap-4 md:gap-6 relative overflow-hidden scroll-mt-28 md:scroll-mt-32 ${isSelected ? 'bg-gradient-to-br from-navy-800 to-navy-900 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.15)] transform scale-[1.02] z-10' : 'bg-navy-800/60 border-navy-700 hover:border-navy-600 hover:bg-navy-800'}`} data-id="element-260">
                  {isSelected && <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-400 to-amber-500" data-id="element-261" />}

                  {/* Radio Indicator */}
                  <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-yellow-400 bg-yellow-400/10' : 'border-gray-500 bg-navy-900/50'}`} data-id="element-262">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-yellow-400 shadow-[0_0_10px_rgba(250,204,21,0.8)]" data-id="element-263" />}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-264">
                    <div className="flex items-center flex-wrap gap-2 mb-1" data-id="element-265">
                      <span className="text-xl shrink-0" data-id="element-266">{p.icon}</span>
                      <h4 className={`text-base md:text-xl font-bold uppercase tracking-tight break-words ${isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-267">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="text-[10px] md:text-xs bg-gradient-to-r from-yellow-400 to-amber-500 text-navy-950 font-black px-3 py-0.5 rounded-full shadow-[0_0_15px_rgba(250,204,21,0.4)] uppercase tracking-wider ml-1" data-id="element-268">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className={`text-xs md:text-base mb-1 break-words ${isSelected ? 'text-gray-100' : 'text-gray-300'}`} data-id="element-269">
                      {p.subtitle}
                    </p>
                    <p className={`text-[10px] md:text-sm font-medium break-words ${isSelected ? 'text-yellow-200/90' : 'text-gray-400'}`} data-id="element-270">
                      {p.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0 ml-auto" data-id="element-271">
                    <p className={`line-through text-[10px] md:text-sm mb-1 ${isSelected ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-272">
                      {p.oldPrice}
                    </p>
                    <p className={`text-xl md:text-4xl font-black transition-colors ${isSelected ? 'text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.4)]' : 'text-white'}`} data-id="element-273">
                      {p.price}{' '}
                      <span className={`text-[10px] md:text-sm font-bold block md:inline ${isSelected ? 'text-yellow-400/70' : 'text-gray-400'}`} data-id="element-274">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-10" data-id="element-275">
            <a href={currentPlan.url} className="w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500 hover:from-yellow-300 hover:via-yellow-400 hover:to-amber-400 text-navy-950 font-black text-lg md:text-2xl py-5 md:py-6 px-4 rounded-2xl flex items-center justify-center transition-all transform hover:scale-[1.03] active:scale-[0.98] shadow-[0_0_40px_rgba(250,204,21,0.4)] border border-yellow-300/50 text-center break-words leading-tight relative overflow-hidden group" data-id="element-276">
              <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-277" />
              <span className="relative z-10" data-id="element-278">
                🟠 → QUIERO EL {currentPlan.buttonText}
              </span>
            </a>
            <div className="flex flex-col items-center mt-6 text-gray-200 text-sm gap-2" data-id="element-279">
              <p className="flex items-center gap-2" data-id="element-280">
                <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" data-id="element-281" />
                Acceso inmediato por email • Pago seguro
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};